class MoveLoginButton {
    constructor() {
        this.loginButton = document.querySelector('.wp-block-loginout');
        this.desktopNavbar = document.querySelector('#menu-header-navigation');
        this.mobileNavbar = document.querySelector('.mobile-menu .nav-news');
        this.moveLogin();
    }

    moveLogin() {
        const desktopItem = this.loginButton;
        desktopItem.classList.add('nav-login');
        const mobileItem = desktopItem.cloneNode(true);
        
        this.desktopNavbar.appendChild(desktopItem);
        
        this.mobileNavbar.parentNode.insertBefore(mobileItem, this.mobileNavbar.nextSibling);
    }
}

export default MoveLoginButton;
